import React from 'react';
import {
  View,
  Pressable,
  StyleSheet,
  Image,
  FlatList,
  Dimensions,
  Platform,
  TouchableOpacity,
} from 'react-native';
import { styles } from './style';
import { addCommasToNumber } from '../../../../utils/utility';
import classes from '../../../../styles/globalClasses';
import gs from '../../../../styles/globalStyles';
import { CaretRight } from '../../../../sharedComponents/Icons/Icons';
import Button from '../../../../sharedComponents/Button/Button';
import FadeInAnimation from '../../../../sharedComponents/FadinAnimation/FadinAnimation';
import Info from '../../../../../assets/Icons/Info';
import Typography from '../../../../sharedComponents/typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens,TypographyTypeDLS } from '@voltmoney/schema';
import { checkColor } from '@app/utils';
import { Theme, ThemedText, ThemedView } from '@app/theme';
import { useTheme } from '@shopify/restyle';
export const SHIMMER_PAGE =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Shimmer_page.png';

export const LimitResultCard = ({
  amount,
  editLimitAction = () => { },
  ctaAction = () => { },
  showEditLimit,
  lastEditDate,
  buttonLoader,
}) => {
  const {colors} = useTheme<Theme>();
  return (
    <FadeInAnimation delay={100} duration={1000}>
      <ThemedView m="lg">
        <ThemedView
          backgroundColor='bg-fill-primary'
          p="lg"
          borderColor='border-primary'
          borderTopLeftRadius='lg'
          borderTopRightRadius='lg'
          style={[
            showEditLimit ? styles.headingWhenEditLimitShown : styles.heading
          ]}>
          <ThemedText variant='b3r' color='text-secondary'>
            {showEditLimit ? "Selected credit limit" : "Available credit limit"}
          </ThemedText>
          <ThemedText variant='h2b' color='text-emphasis-secondary' fontWeight='700' fontFamily='Inter'>
            {'₹' + addCommasToNumber(amount)}
          </ThemedText>
        </ThemedView>
        {showEditLimit ? (
          <ThemedView style={styles.subHeadingAndroidIOS} backgroundColor='bg-fill-primary'>
            <ThemedView
              backgroundColor='bg-surface-secondary'
              style={{
                height: 30,
                // backgroundColor: '#F1F3F5',
                borderRadius: 6,
                paddingHorizontal: 12,
                flexDirection: 'row',
                marginLeft: 20,
                marginRight: 16,
                marginBottom: 16,
                alignContent: 'center',
                alignItems: 'center',
              }}>
              <Info size={16} color={colors['icon-secondary']} />
              <View style={{ marginLeft: 8}}>
                <ThemedText variant='b3r' color='text-secondary'>
                  {`Last checked on ${lastEditDate}`}
                </ThemedText>
              </View>
            </ThemedView>

            <View
              style={{
                flexDirection: 'row',
                alignContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginBottom: 16,
                justifyContent: 'center',
                flex: 1,
                padding: 16,
              }}>
              <View style={{ flex: 0.38, marginRight: 8, height: 32 }}>
                <Button
                  eventName='DASHBOARD_EDIT_LIMIT_CLICKED'
                  size="MD"
                  handlePress={editLimitAction}
                  type="OUTLINED"
                  label={'Edit limit'}
                  showRightAccessory={true}
                  rightAccessory={() => {
                    return (
                      <CaretRight size={16} weight="bold" color={colors['icon-primary']} />
                    );
                  }}
                />
              </View>
              <View style={{ flex: 0.62, height: 32 }}>
                {(
                  <Button
                    size="MD"
                    label={'Continue application'}
                    type={'SOLID'}
                    eventName='AFTER_LIMIT_CONTINUE_APPLICATION'
                    showShadow={true}
                    buttonLoader={buttonLoader}
                    handlePress={ctaAction}
                    showRightAccessory={true}
                    rightAccessory={() => {
                      return (
                        <CaretRight size={16} weight="bold" color="#fff" />
                      );
                    }}
                  />
                )}
              </View>
            </View>
          </ThemedView>
        ) : (
          <ThemedView style={styles.subHeading} backgroundColor='bg-fill-primary' borderColor='border-primary'>
            <View style={styles.subHeadingContainer}>
              <View style={styles.imageContainer}>
                <Image
                  source={{ uri: SHIMMER_PAGE }}
                  style={styles.shimmerImage}
                />
              </View>
              <View style={styles.textContainer}>
                <ThemedText variant="b1s" color='text-primary'>
                  {"You’re almost there!"}
                </ThemedText>
                <ThemedText variant="b4b" color='text-placeholder'>
                  {"Finish application in a few minutes"}
                </ThemedText>
              </View>
            </View>
            <View
              style={styles.buttonContainer}
              nativeID="bt_landingScreen_continueApplication">
              <Button
                size="LG"
                label={'Continue application'}
                eventName='AFTER_LIMIT_CONTINUE_APPLICATION'
                type={'SOLID'}
                showShadow={true}
                buttonLoader={buttonLoader}
                handlePress={ctaAction}
              />
            </View>
          </ThemedView>
        )}
      </ThemedView>
    </FadeInAnimation>
  );
};
